<template>
<div class="signup-container">
        <h2>Sign up</h2>
        <div class="field">
            <b-input class="inputs" v-model="firstName" placeholder="First Name"></b-input>
        </div>

        <div class="field">
            <b-input v-model="lastName" placeholder="Last Name"></b-input>
        </div>

        <div class="field">
            <b-input v-model="email" placeholder="User Id"></b-input>
        </div>
            
         <div class="field">
            <b-input type="password"
                v-model="password"
                placeholder="Password"
                password-reveal>
            </b-input>
        </div>

        <button class="button signup" type="button" @click="signUp">Create account</button>
        <p>or go back to <router-link to="/login">login</router-link> </p>
</div>

</template>

<script>
import userService from '../services/userService.js'

export default {
  name: 'signup',
  data() {
    return{
      email: '',
      password:'',
      firstName:'',
      lastName:''
    }
  },
  methods:{
    signUp:function(){
        const me = this;
        userService.getUserSignupPromise(me.email + '@nuri.com', me.password).then(
            function(response)
            {
                userService.addUser(response.user.uid, me.firstName, me.lastName)
                alert("your account has be created!")
            },
            function(err){
                alert("oops");
            }
        )
    }
  }
}
</script>

<style>
.signup-container{
    margin: 0 auto;
    width: 400px;
    height: 450px;
    padding: 30px;
    border-radius: 0px;
    background: rgba(255, 255, 255, 0.4);
     border: 0px solid #6eb7e7;
    -webkit-box-shadow: 0px 0px 2px #5eb0e5;
    box-shadow: 0px 0px 2px #5eb0e5;
}
.signup-container  h1 {
    font-size: 12px;
}
.signup-container  input{
    width:100%;
    margin: 10px 0px;
    height:40px!important;
    border-radius: 0px!important;
}
.signup-container p{
    font-size: 12px;
}
.signup-container h2{
    padding:10px;
    text-align: center;
}
.signup-container .icon{
    right: 5px!important;
    top: 18px!important;
}
.label{
    width:100%;
    margin-top:15px;
    color:gray;
    font-size: 14px;
}
button.signup{
    margin-top:20px;
    width: 100%!important;
    height:40px;
    background: #5Eb0e5;
    color:white;
}
button.signup:hover{
    background: #6eb7e7;
    border: 0px;
    color:white;
}
</style>